import React, { useEffect, useState } from "react";
import { Offcanvas, Button, Spinner, Dropdown } from "react-bootstrap";

import "react-datepicker/dist/react-datepicker.css";
import edit from "../../../assets/Asssignment/edit.png";
import trash from "../../../assets/Asssignment/delete.png";
import closeoff from "../../../assets/Asssignment/close.png";
import user from "../../../assets/svg/User.svg";
import chevron_down from "../../../assets/Vehicles/chevron_down.png";
import { getKmHistDetAPI } from "./km_history_api";
import { useGlobal } from "../../../GlobalContext.js";

const KmHistoryView = ({ id, showEdit, showDelete, show, handleClose }) => {
  const { rolePermissionList, userType } = useGlobal();

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    console.log("Consilee", id);
    if (id != null && id !== 0) {
      getKmHistoryView();
    }
  }, [id]);
  const [kmHistoryView, setKmHistoryView] = useState(null);
  const getKmHistoryView = async () => {
    try {
      const response = await getKmHistDetAPI(id);

      console.log("Km  details", response);
      if (response.data?.success) {
        const vehicleData = response.data.history;
        setKmHistoryView(vehicleData);
      } else {
        console.error(
          "Failed to fetch vehicle details:",
          response.data?.message
        );
      }
    } catch (err) {
      console.error("Error fetching vehicle details:", err);
    }
  };
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }
  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      style={{ width: "520px" }}
    >
      <Offcanvas.Header
        closeButton={false}
        className="d-flex justify-content-between align-items-center p-0"
      >
        <Offcanvas.Title className="bg-grey w-100 p-3 d-flex flex-wrap justify-content-center align-items-center justify-content-xl-between">
          <div>
            <p className="m-0 fs-20 fw-800 mb-1">
              {" "}
              {kmHistoryView?.lic_no ?? "-"}
            </p>
            <div className="d-flex align-items-center">
              <span className="me-2 text-muted-grey fs-13 fw-600">
                {kmHistoryView?.vehicle_label ?? "-"}
              </span>
              <span className="me-2" style={{ color: "#D9D9D9" }}>
                •
              </span>
              <span className="border-0 bg-white text-dark-purple py-1 px-4 rounded-pill fs-13 fw-400">
                <span className="text-muted-grey"> VIN : </span>
                {kmHistoryView?.vin ?? "-"}
              </span>
            </div>
          </div>
          <div className="d-flex gap-3">
            {checkPermission("KM History", "edit_permission") && (
              <img
                src={edit}
                alt="edit"
                className="cursor-pointer"
                onClick={() => {
                  handleClose();
                  showEdit(id);
                }}
              />
            )}
            {checkPermission("KM History", "delete_permission") && (
              <img
                src={trash}
                alt="trash"
                className="cursor-pointer"
                onClick={() => {
                  handleClose();
                  showDelete(id);
                }}
              />
            )}

            <img
              src={closeoff}
              alt="closeoff"
              className="cursor-pointer"
              onClick={handleClose}
            />
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div>
          <p className="m-0 fs-15 fw-600">Other details</p>
          <div className="table-container rounded-4 overflow-hidden my-3">
            <table className="table table-borderless mb-0">
              <tbody>
                <tr>
                  <td
                    className="fs-13 fw-500"
                    style={{ color: "#49494B", width: "25%" }}
                  >
                    Last Km recorded
                  </td>
                  <td
                    className="fs-13 fw-400"
                    style={{ color: "#172B4D", width: "75%" }}
                  >
                    {kmHistoryView?.last_km ?? "-"} km
                  </td>
                </tr>

                <tr>
                  <td className="fs-13 fw-500" style={{ color: "#49494B" }}>
                    Current Km
                  </td>
                  <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                    {kmHistoryView?.current_km ?? "-"} km
                  </td>
                </tr>
                <tr>
                  <td className="fs-13 fw-500" style={{ color: "#49494B" }}>
                    Driver driven
                  </td>
                  <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                    {kmHistoryView?.driven_km ?? "-"} km
                  </td>
                </tr>
                <tr>
                  <td className="fs-13 fw-500" style={{ color: "#49494B" }}>
                    Driver
                  </td>
                  <td
                    className="fs-13 fw-400 d-flex align-items-center"
                    style={{ color: "#172B4D", gap: "8px" }}
                  >
                    <img
                      src={user}
                      alt="tata"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <div> {kmHistoryView?.driver ?? "-"}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr />
          <p className="m-0 pagination-color fs-15 fw-600">Attached image</p>
          {kmHistoryView?.image && (
            <div className="receipt-container position-relative">
              <img
                src={kmHistoryView.image}
                alt={`Receipt-${kmHistoryView.id ?? "unknown"}`} // dynamic alt
                key={kmHistoryView.image} // forces React to re-render if image changes
                className="receipt-image"
              />
            </div>
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default KmHistoryView;
